const deepMerge = (target, source) => {
  const result = { ...target };
  Object.keys(source).forEach((key) => {
    if (
      source[key]
      && typeof source[key] === 'object'
      && !Array.isArray(source[key])
      && target[key]
      && typeof target[key] === 'object'
      && !Array.isArray(target[key])
    ) {
      result[key] = deepMerge(target[key], source[key]);
    } else {
      result[key] = source[key];
    }
  });
  return result;
};

export default deepMerge;
